<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="账号">
              <a-input placeholder="请输入账号" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
              <a-form-item label="主管部门">
                  <a-select
                          show-search
                          v-model="where.keyword.administration"
                          :filter-option="filterOption"
                          allowClear
                          @change="administrationChanged"
                  >
                      <a-select-option
                              :value="info.itemName"
                              v-for="(info, index) in administrationList"
                              :key="index"
                      >{{info.itemName}}
                      </a-select-option>
                  </a-select>
              </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="用户组">
              <a-select
                      show-search
                      v-model="where.keyword.groupIds"
                      :filter-option="filterOption"
                      allowClear
                      @change="groupChanged"
              >
                <a-select-option
                        :value="info.id"
                        v-for="(info, index) in grouplist"
                        :key="index"
                >{{info.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
           <a-col :span="10">
              <a-form-item label="所在地区">
                <a-cascader
                        :options="areas"
                        placeholder="请选择所在地区"
                        @change="onAreachange"
                        change-on-select
                        :default-value="areaList"
                        :fieldNames="{ label: 'name', value: 'name', children: 'children' }"
                />
              </a-form-item>
            </a-col>
          <a-col :span="2" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'统计管理员列表-搜索'">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo(0, 1)" type="primary" v-btnlimit="'统计管理员列表-添加'"/>

      <a-alert type="info" showIcon style="margin-bottom:20px">
        <span slot="message">
          已选择 {{selectRows.length}} 项
          <a
            @click="clearRows"
            style="color: #1890ff;margin-left:10px"
          >清空</a>
        </span>
      </a-alert>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="sourceType" slot-scope="sourceType">
          <span v-if="sourceType==0">个人注册</span>
          <span v-else>系统导入</span>
        </span>
        <span slot="permissionType" slot-scope="permissionType">
          <a-tag v-if="permissionType==0" >主管部门权限</a-tag>
          <a-tag v-else >地区权限</a-tag>
        </span>

        <span slot="status" slot-scope="status">
          <a-tag v-if="status==0" color="red">禁用</a-tag>
          <a-tag v-else color="green">启用</a-tag>
        </span>

        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            :roles="[]"
            v-btnlimit="'统计管理员列表-编辑'"
            @click="showInfo(action.id,2,action.userId)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />

          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <pxkeji-btn
                        :name="action.status==1?'禁用':'启用'"
                        v-btnlimit="'统计管理员列表-启用禁用'"
                        @click="bthEnable(action.id,action.status)"
                        size="small"
                        type="default"
                        class="pxkeji_dro_btn"
                />
              </a-menu-item>
              <a-menu-item key="2">
                <pxkeji-btn
                    name="解锁"
                    v-btnlimit="'统计管理员列表-解锁'"
                    :roles="[]"
                    @click="unlocking(action.id)"
                    size="small"
                    type="dashed"
                />
              </a-menu-item>
            </a-menu>
            <a-button size="small" type="dashed" v-btnlimit="'统计管理员列表-更多'">
              更多
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>用户总人数：{{list.pagination.total}}个</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1000px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :userId="addedit.userId" />
    </a-modal>
  </div>

</template>
<script>
var that;
import Info from "./statisticsUserRoleSettingInfo.vue"; //新增编辑
const columns = [
  {
    dataIndex: "realName",
    key: "realName",
    align: "center",
    title: "姓名"
  },

 /* {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号"
  },*/

  {
    dataIndex: "addTime",
    key: "addTime",
    align: "center",
    title: "添加时间"
  },
  {
    dataIndex: "permissionType",
    key: "permissionType",
    align: "center",
    title: "权限类型",
    scopedSlots: { customRender: "permissionType" }
  },
/*  {
    dataIndex: "administration",
    key: "administration",
    align: "center",
    title: "主管部门"
  },*/
  {
    dataIndex: "province",
    key: "province",
    align: "center",
    title: "地区",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  name: "couponlist",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },

      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      },
      //积分明细
      integral: {
        info: {},
        visible: false
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          startTime: "",
          endTime: "",
          enterpriseName: "",
          sourceType: "",
          // 2021 11 01 start
          province:"",
          city:"",
          area:"",
          administration:"",
          groupIds:"",
          // 2021 11 01 end
        }
      },
      courseModal: {
        courseShow: false,
        id: 0,
      },
      selectRows: [], //选中项编号
      isloading: false,
      grouplist: [],
      // 2021 11 01 start
      areas:[],
      areaList: [],
      administrationList:[],
      // 2021 11 01 end
      visible: false //弹框
    };
  },
  components: {
    Info,
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.getgrouplist();
      this.GetList();
      this.areas=this.$api.city.city;//2021 11 01
      this.getDictionaryItem(); //2021 11 01
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {

    unlocking(id) {
      that = this;
      that.isloading = true;
      that.$api.user
          .unlockingUser(id)
          .then(res => {
            that.isloading = false;
            if (res.errorCode == that.$msg.responseCode.success) {
              that.$message.success(res.errorMsg);
              that.GetList();
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            that.isloading = false;
          });
    },
    // 2021 11 01 start
      //获取数据字典
      getDictionaryItem() {
        this.$api.dictionaryItem.tree(23).then((res) => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.administrationList = res.data;
          } else {
            this.error(res.errorMsg);
          }
        });

    },
    administrationChanged(v) {
        this.where.keyword.administration = v;
    },
    onAreachange(v){
      if(v[0]){
          this.where.keyword.province=v[0];
        }else{
          this.where.keyword.province='';
        }
        if(v[1]){
          this.where.keyword.city=v[1];
        }else{
          this.where.keyword.city='';
        }
        if(v[2]){
          this.where.keyword.area=v[2];
        }else{
          this.where.keyword.area='';
        }
    },
    // 2021 11 01 end
    toggle() {
      this.expand = !this.expand;
    },
    groupChanged(v) {
      this.where.keyword.groupIds = v;
    },
    getgrouplist() {
      this.isloading = true;
      this.$api.usergroup
        .getAll()
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.grouplist = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    /*启用禁用*/
    bthEnable(ids, status) {
      that.isloading = true;
      that.$api.student.changepermissionuserstatus(ids, status == 1 ? 0 : 1)
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                  that.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
              });
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();



      this.$api.student
        .getpermissionuserPageList(
             this.list.pagination.current,
             this.list.pagination.defaultPageSize,
                this.where.keyword.name,
                 this.where.keyword.province,
            this.where.keyword.city,
            this.where.keyword.area,
            this.where.keyword.administration,
            this.where.keyword.groupIds,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            var item =res.data.records;
            for (let i = 0; i < item.length; i++) {
              if(item[i].city){
                item[i].province=item[i].province+"/"+item[i].city
              }
              if(item[i].area){
                item[i].province=item[i].province+"/"+item[i].area // 2021 09 11
              }
            }
            this.list.datas = item;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },



    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(id, type,userId) {
      //打开弹出框
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "编辑";
      }
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.userId = userId;
      this.addedit.type = type;
    },

    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {},
        onCancel() {}
      });
    },


    save() {
      this.addedit.visible = false;
      this.integral.visible = false;
      this.GetList();
    },



  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

